import { render, staticRenderFns } from "./ResponseModal.vue?vue&type=template&id=af8291c6&scoped=true"
import script from "./ResponseModal.vue?vue&type=script&lang=js"
export * from "./ResponseModal.vue?vue&type=script&lang=js"
import style0 from "./ResponseModal.vue?vue&type=style&index=0&id=af8291c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8291c6",
  null
  
)

export default component.exports